import { render, staticRenderFns } from "./GameOverScreen.vue?vue&type=template&id=adaeda0c"
import script from "./GameOverScreen.vue?vue&type=script&lang=js"
export * from "./GameOverScreen.vue?vue&type=script&lang=js"
import style0 from "./GameOverScreen.vue?vue&type=style&index=0&id=adaeda0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports